import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Inspections from "@/pages/Inspections";
import InspectionCapture from "@/pages/InspectionCapture";
import ReportReview from "@/pages/ReportReview";
import Reports from "@/pages/Reports";
import Scheduling from "@/pages/Scheduling";
import Notices from "@/pages/Notices";
import Compliance from "@/pages/Compliance";
import TenancyRules from "@/pages/TenancyRules";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import TenantPortal from "@/pages/TenantPortal";
import OwnerReport from "@/pages/OwnerReport";
import ResetPassword from "@/pages/ResetPassword";
import EvidencePack from "@/pages/EvidencePack";
import FloorPlanPin from "@/pages/FloorPlanPin";
import Comparison from "@/pages/Comparison";
import Handovers from "@/pages/Handovers";
import HandoverPortal from "@/pages/HandoverPortal";
import Insights from "@/pages/Insights";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center" style={{ background: "var(--bg)" }}>
      <div className="h-8 w-8 rounded-full shimmer" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portal/:token" element={<TenantPortal />} />
            <Route path="/owner/:token" element={<OwnerReport />} />
            <Route path="/handover/:token" element={<HandoverPortal />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/properties" element={<Protected><Properties /></Protected>} />
            <Route path="/properties/:id" element={<Protected><PropertyDetail /></Protected>} />
            <Route path="/inspections" element={<Protected><Inspections /></Protected>} />
            <Route path="/inspections/:id/capture" element={<Protected><InspectionCapture /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/reports/:id/review" element={<Protected><ReportReview /></Protected>} />
            <Route path="/reports/:id/evidence" element={<Protected><EvidencePack /></Protected>} />
            <Route path="/reports/:id/plan" element={<Protected><FloorPlanPin /></Protected>} />
            <Route path="/reports/:id/comparison" element={<Protected><Comparison /></Protected>} />
            <Route path="/schedule" element={<Protected><Scheduling /></Protected>} />
            <Route path="/notices" element={<Protected><Notices /></Protected>} />
            <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
            <Route path="/tenancy-rules" element={<Protected><TenancyRules /></Protected>} />
            <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
            <Route path="/handovers" element={<Protected><Handovers /></Protected>} />
            <Route path="/insights" element={<Protected><Insights /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
